import * as remoteAction from "../remoteAction";

export type GetReferralActionSuccess = remoteAction.MerchantRemoteResponse<
  "GET_REFERRAL_SUCCESS",
  any,
  GetReferralParams
>;
export type GetReferralActionFailure = remoteAction.MerchantRemoteResponse<
  "GET_REFERRAL_FAILURE",
  any,
  GetReferralParams
>;
export type GetReferralActionRequest = remoteAction.MerchantRemoteResponse<
  "GET_REFERRAL_REQUEST",
  any,
  GetReferralParams
>;

export interface GetReferralAction extends remoteAction.PostRemoteRequest {
  types: {
    request: "GET_REFERRAL_REQUEST";
    success: "GET_REFERRAL_SUCCESS";
    failure: "GET_REFERRAL_FAILURE";
  };
}

export interface GetReferralParams {
  merchantId: string;
  campaignId: string;
  widgetConfigId: string;
  seed?: string;
  prefix?: string;
  email: string;
  channel: string;
  [props: string]: string | undefined;
}

export const getReferral = ({
  merchantId,
  campaignId,
  widgetConfigId,
  email,
  seed,
  prefix,
  channel = "email",
  ...other
}: GetReferralParams): GetReferralAction => ({
  type: "MERCHANT_REMOTE_REQUEST",
  types: {
    request: "GET_REFERRAL_REQUEST",
    failure: "GET_REFERRAL_FAILURE",
    success: "GET_REFERRAL_SUCCESS",
  },
  method: "POST",
  https: true,
  data: {
    merchantId,
    campaignId,
    widgetConfigId,
    email,
    channel,
    seed: seed || "",
    prefix: prefix || "",
    ...other,
  },
  url: `/share/referral/short`,
});
